import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const ease = [0.22, 1, 0.36, 1];

const SECTIONS = [
  {
    title: "Domande frequenti",
    items: [
      { q: "Le composizioni possono essere personalizzate?", a: "No. Ogni composizione nasce per trasmettere un messaggio e custodire un'intenzione attraverso un equilibrio studiato tra fiori, colori e cristallo. Modificare uno di questi elementi significherebbe cambiarne il significato originario." },
      { q: "I fiori sono veri?", a: "Sì. Tutte le creazioni sono realizzate con fiori veri essiccati o stabilizzati." },
      { q: "Qual è la differenza tra fiori essiccati e stabilizzati?", a: "I fiori essiccati asciugano naturalmente; quelli stabilizzati vengono trattati per conservarsi più a lungo." },
      { q: "Quanto durano?", a: "Se ben conservate, possono mantenersi per molti anni." },
      { q: "Come si conservano?", a: "In ambiente asciutto, lontano da sole diretto, acqua e umidità. Spolverare delicatamente con un pennello morbido." },
      { q: "Possono stare all'esterno?", a: "No, sono pensate esclusivamente per ambienti interni." },
      { q: "Il cristallo è compreso?", a: "Sì, ogni composizione custodisce un cristallo naturale." },
      { q: "I cristalli sono naturali?", a: "Sì, possono presentare naturali variazioni di forma, colore e venature." },
      { q: "Posso cambiare il cristallo?", a: "No. Ogni cristallo è scelto per il significato della composizione." },
      { q: "Hanno proprietà terapeutiche?", a: "No. Le creazioni hanno esclusivamente valore artistico e simbolico e non sostituiscono cure o pareri medici." },
      { q: "Ogni composizione è un pezzo unico?", a: "Sì. Essendo realizzate a mano con elementi naturali, ogni creazione è irripetibile." },
      { q: "Posso regalarla senza conoscerne il significato?", a: "Sì. Ogni composizione è accompagnata da un biglietto che ne racconta il messaggio." },
    ],
  },
  {
    title: "Spedizione",
    items: [
      { q: "Come vengono spedite?", a: "Ogni creazione viene confezionata con un imballaggio accurato e protettivo." },
      { q: "Quali sono i tempi di preparazione?", a: "Le tempistiche vengono comunicate prima della conferma dell'ordine." },
      { q: "Posso richiedere una data di consegna?", a: "Contattaci prima dell'acquisto e faremo il possibile per rispettarla." },
      { q: "Come posso seguire la spedizione?", a: "Dopo la spedizione riceverai il codice di tracciamento (tracking), con cui potrai seguire il tuo ordine fino alla consegna." },
      { q: "E se il pacco arriva danneggiato?", a: "Ogni creazione viene imballata con la massima cura. Se, nonostante questo, dovesse arrivare danneggiata durante il trasporto, saremo felici di trovare insieme la soluzione migliore, sostituendo la composizione (quando possibile) oppure procedendo al rimborso." },
    ],
  },
  {
    title: "Cerimonie",
    items: [
      { q: "Realizzate bomboniere?", a: "Sì, realizziamo bomboniere artigianali per Battesimi, Comunioni, Cresime." },
      { q: "È possibile ricevere un campione?", a: "Non realizziamo campioni. Le fotografie rappresentano fedelmente le creazioni e, su richiesta, possiamo fornire ulteriori immagini e informazioni." },
      { q: "Quante bomboniere posso ordinare?", a: "Realizziamo sia piccole che grandi quantità. Contattaci indicando il numero desiderato e prepareremo una proposta su misura." },
      { q: "Quanto tempo prima devo ordinarle?", a: "Consigliamo di effettuare l'ordine almeno 3 mesi prima, soprattutto nei periodi di maggiore richiesta. Si consiglia di contattarci sui social per quantità superiori a 20 unità." },
      { q: "Le bomboniere sono tutte identiche?", a: "Seguono tutte lo stesso stile della collezione scelta. Essendo prodotti artigianali realizzati con elementi naturali, possono esserci piccole differenze che rendono ogni pezzo unico." },
    ],
  },
];

export default function FAQ() {
  let idx = 0;
  return (
    <div className="relative z-10 pt-36 pb-28 max-w-3xl mx-auto px-6 md:px-10">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease }}>
        <p className="text-sm uppercase tracking-[0.3em] text-gold mb-4">Domande frequenti</p>
        <h1 className="font-serif text-5xl md:text-7xl font-light leading-none mb-6" data-testid="faq-title">FAQ</h1>
        <p className="text-lg text-muted-foreground max-w-xl mb-14">Tutto ciò che c'è da sapere sui nostri incanti, sulle spedizioni e sulle cerimonie. Non trovi la risposta? Scrivici.</p>
      </motion.div>

      {SECTIONS.map((section, si) => (
        <div key={si} className="mb-14" data-testid={`faq-section-${si}`}>
          <h2 className="font-serif text-3xl md:text-4xl font-light mb-4 text-gold">{section.title}</h2>
          <Accordion type="single" collapsible className="w-full">
            {section.items.map((f) => {
              const i = idx++;
              return (
                <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="text-left font-serif text-lg md:text-xl hover:text-gold hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-muted-foreground leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              );
            })}
          </Accordion>
        </div>
      ))}

      <div className="mt-4 text-center bg-secondary/40 border border-border rounded-lg p-10">
        <h2 className="font-serif text-3xl font-light mb-3">Hai altre domande?</h2>
        <p className="text-muted-foreground mb-6">Siamo qui per aiutarti a trovare l'incanto giusto.</p>
        <a href="mailto:incantidestate@gmail.com" className="inline-block rounded-full bg-gold hover:bg-gold/90 text-white px-8 py-3 transition-colors" data-testid="faq-contact-btn">
          Scrivici a incantidestate@gmail.com
        </a>
      </div>
    </div>
  );
}
